<template>
  <div class="card">
    <div class="card-body">
      <h4>{{ "admin_contact" | t }}</h4>
      <hr />
      <div v-for="(value, key) in adminContactInfo" :key="key" class="mb-2 row">
        <div class="col-md-4">
          <strong>{{ key | t }}</strong>
        </div>
        <div class="col-md-8">{{ value }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    customer: Object,
  },
  computed: {
    adminContactInfo() {
      return {
        name: this.customer.admin_contact_name,
        phone: this.customer.admin_contact_phone,
        email: this.customer.admin_contact_email,
      };
    },
  },
};
</script>